import { useEffect, useState } from 'react'
import CloseIcon from '../../../assets/CloseIcon'
import ReminderIcon from '../../../assets/ReminderIcon'
import SearchIcon from '../../../assets/SearchIcon'
import { INVENTORY_STAGES, INVENTORY_TABS } from '../../../common/constant/page-constant'
import useCheckMobileScreen from '../../../common/hooks/use-check-mobile-screen-hook'
import { getReminderHelper } from '../../../helper/query-helper'
import { getInventoryDetailsHelper } from '../../../helper/home-helper'

const InventoryFilter = ({
  filterOptions,
  setFilterOptions,
  inventoryStage,
  setInventoryStage,
  activeTab,
  inventoryData,
  onReminderFilter,
  isReminderFilterActive,
}) => {
  const [searchTerm, setSearchTerm] = useState(filterOptions?.search || '')
  const [expiringCount, setExpiringCount] = useState(0)
  const [reminderDays, setReminderDays] = useState(0)
  const isMobile = useCheckMobileScreen()

  useEffect(() => {
    fetchReminderAndCount()
  }, [activeTab])

  const fetchReminderAndCount = () => {
    const productType = activeTab === INVENTORY_TABS.PHARAMCEUTICAL 
      ? 'PHARMACEUTICAL' 
      : 'NON_PHARMACEUTICAL'

    getReminderHelper()
      .then(reminders => {
        // Filter reminders by product type and find the one with MAX days
        // This ensures we catch all products expiring within the largest reminder window
        const matchingReminders = reminders?.filter(r => r.product_type === productType) || []
        const maxDaysReminder = matchingReminders.reduce((max, r) => 
          (r.days > (max?.days || 0)) ? r : max, null
        )
        
        if (maxDaysReminder?.days) {
          setReminderDays(maxDaysReminder.days)
          // Fetch count of expiring products from server
          fetchExpiringProductCount(productType, maxDaysReminder.days)
        } else {
          setReminderDays(0)
          setExpiringCount(0)
        }
      })
      .catch(() => {
        setReminderDays(0)
        setExpiringCount(0)
      })
  }

  const fetchExpiringProductCount = (productType, days) => {
    const params = {
      type: productType,
      expiry_days: days,
      page: 1,
      limit: 1, // Only need count from pagination, not actual data
    }
    
    getInventoryDetailsHelper(undefined, params)
      .then(response => {
        const count = response?.pagination?.count || 0
        setExpiringCount(count)
      })
      .catch(() => {
        setExpiringCount(0)
      })
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    setFilterOptions({ search: searchTerm })
  }

  const handleClearSearch = (e) => {
    e.preventDefault()
    if (!searchTerm) return
    setSearchTerm('')
    setFilterOptions({ search: '' })
  }

  const handleReminderClick = () => {
    if (reminderDays > 0) {
      onReminderFilter(reminderDays)
    }
  }

  const handleClearFilter = () => {
    setInventoryStage(INVENTORY_STAGES.PRODUCT_LISTING)
    onReminderFilter(0)
  }

  return (
    <>
      {isMobile && (
        <div className="addProductBtnMobile dFlex flexColumnReverse aiCenter mwebVisible fixed">
          {inventoryStage === INVENTORY_STAGES.PRODUCT_LISTING && (
            <div className="formGroup mb-0 searchBar expand">
              <form onSubmit={handleSearchSubmit}>
                <input
                  type="text"
                  className="formControl"
                  placeholder="Search By Product Name or Generic Name"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSearchSubmit(e)
                    }
                  }}
                />
              </form>
              <div className="searchIcon" onClick={handleSearchSubmit}>
                <SearchIcon />
              </div>
              <div className="closeIcon" onClick={handleClearSearch}>
                <CloseIcon />
              </div>
            </div>
          )}
          <button 
            className={`animated zoomIn btn ${isReminderFilterActive ? 'btnPrimary' : 'btnSecondary'} pointer mb-2`}
            onClick={handleReminderClick}
          >
            <ReminderIcon count={expiringCount} />
          </button>
        </div>
      )}
      {!isMobile && (
        <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter">
          <div className="pageBodyRightPanelHeading">Manage Inventory</div>
          <div className="addProductBtn dFlex aiCenter">
            {inventoryStage === INVENTORY_STAGES.PRODUCT_LISTING && (
              <div className="formGroup mb-0 searchBar expand">
                <form onSubmit={handleSearchSubmit}>
                  <input
                    type="text"
                    className="formControl"
                    placeholder="Search By Product Name or Generic Name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleSearchSubmit(e)
                      }
                    }}
                  />
                </form>
                <div className="searchIcon" onClick={handleSearchSubmit}>
                  <SearchIcon />
                </div>
                <div className="closeIcon" onClick={handleClearSearch}>
                  <CloseIcon />
                </div>
              </div>
            )}
            <div 
              className={`pointer ml-4 ${isReminderFilterActive ? 'reminderActive' : ''}`}
              title={`${expiringCount} products expiring soon`}
              onClick={handleReminderClick}
              style={{ cursor: reminderDays > 0 ? 'pointer' : 'default' }}
            >
              <ReminderIcon count={expiringCount} />
            </div>
            <div
              className="pointer ml-4"
              onClick={handleClearFilter}
            >
              <CloseIcon />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default InventoryFilter
